import React, { useState, useRef } from 'react'
import { formattedDate } from '../../utils/formattedDate';
import EditReport from '../Reports/EditReport';
import { suspendReportApi } from '../../api/usersApi';

const ReportTab = ({ reportList, reportEditRef, isEditReport, setEditReport, userApi, fetchUserCount, setEdit, setShowNotification, setNotificationMessage, setTotalPage, setUserList, currentPage, setCurrentPage }) => {

    const [selectedReport, setSelectedReport] = useState({});
    const [isSuspendLoading, setIsSuspendLoading] = useState(false);
    const [isIgnoreLoading, setIsIgnoreLoading] = useState(false);

    const convertToDecimalHour = (isoTime) => {
        const date = new Date(isoTime);
        const hours = date?.getHours();
        const minutes = date?.getMinutes();
        const decimalMinutes = (minutes / 60).toFixed(2);
        const result = (hours + parseFloat(decimalMinutes)).toFixed(2);

        return result?.replace('.', ':');
    };

    const actionReport = async (reportId, status) => {
        try {
            await suspendReportApi({
                reportId,
                status,
            });
            return true;
        } catch (error) {
            console.error('API error:', error.response?.data || error.message);
            return false;
        }
    };

    const handleSuspendUser = async (editSliderData) => {
        setIsSuspendLoading(false);
        try {
            setIsSuspendLoading(true)
            const success = await actionReport(editSliderData?.id, "SUSPENDED");
            if (success) {
                const data = await userApi();
                if (data) {
                    setUserList(data?.list)
                    setTotalPage(data?.totalPage)
                    if (data?.list?.length === 0) {
                        setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)
                    }

                }
                await fetchUserCount();
                setShowNotification(true);
                setNotificationMessage(`${editSliderData?.reportedName || ""} was suspended and the report has been successfully closed.` || "");
                setTimeout(() => {
                    setShowNotification(false);
                }, 8000);
                setEditReport(false)
                setEdit(false)
            } else {
                setIsIgnoreLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsSuspendLoading(false);
        }
    }

    const handleIgnoreUser = async (editSliderData) => {
        try {
            setIsIgnoreLoading(true)
            const success = await actionReport(editSliderData?.id, "IGNORED");
            if (success) {
                setEditReport(false);
                setShowNotification(true);
                setNotificationMessage('The report has been successfully ignored & closed.' || "");
                setTimeout(() => {
                    setShowNotification(false);
                }, 8000);
            } else {
                setIsIgnoreLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsIgnoreLoading(false);
        }
    }

    return (
        <>
            <div className='founder-reports'>
                <div className='founder-report-section'>
                    {
                        reportList?.length > 0 &&
                        <div className="report-list">
                            <>
                                {
                                    reportList?.map((item, index) => {
                                        return <div className='report-list-card' key={index} onClick={() => { setEditReport(true); setSelectedReport(item); }}>
                                            <div className='card-description'>
                                                <div className="list-name">Report #{item?.id}</div>
                                            </div>
                                            <div className='card-time'>
                                                <div className='card-time'>
                                                    {`${formattedDate(item?.dateOfReported)} ${convertToDecimalHour(item?.dateOfReported)}` || "0:00"}
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </>
                        </div>
                    }
                </div>
            </div>
            <EditReport
                setEditReport={setEditReport}
                ref={reportEditRef}
                selectedReport={selectedReport}
                isEditReport={isEditReport}
                handleActionUser={handleSuspendUser}
                isSuspendLoading={isSuspendLoading}
                setSelectedReport={setSelectedReport}
                handleIgnoreUSer={handleIgnoreUser}
                isIgnoreLoading={isIgnoreLoading}
            />
        </>
    )
}

export default ReportTab